{
  "authenticating": "Laddar...",
  "welcomeVsaAdmin": "Välkommen till Vsaa Admin",
  "entraGroupMembership": {
    "title": "Behörigheter",
    "description": "Lägg till eller ta bort medlemmar i en Vsaa-behörighetsgrupp.",
    "manage": "Hantera behörigheter",
    "groupLabel": "Behörighetsgrupp",
    "groupPlaceholder": "Välj behörighetsgrupp",
    "userLabel": "Användare",
    "userHint": "Skriv minst två tecken för att söka efter användare.",
    "userPlaceholder": "Sök på namn eller e-postadress",
    "add": "Lägg till medlem",
    "success": "Användaren har lagts till i behörighetsgruppen.",
    "alreadyMember": "Användaren är redan medlem i behörighetsgruppen.",
    "error": "Det gick inte att lägga till användaren. Försök igen senare.",
    "membersTitle": "Medlemmar",
    "membersLoading": "Laddar medlemmar...",
    "membersEmpty": "Gruppen har inga medlemmar.",
    "membersError": "Det gick inte att hämta gruppens medlemmar. Försök igen senare.",
    "memberName": "Namn",
    "memberEmail": "E-postadress",
    "memberActions": "Åtgärder",
    "removeMember": "Ta bort medlem",
    "removeMemberTitle": "Ta bort medlem",
    "removeMemberPrompt": "Är du säker på att du vill ta bort {{name}} från behörighetsgruppen?",
    "remove": "Ta bort",
    "removeSuccess": "Medlemmen har tagits bort från behörighetsgruppen.",
    "removeError": "Det gick inte att ta bort medlemmen. Försök igen senare.",
    "removeStale": "Medlemmen finns inte längre i gruppen. Listan har laddats om.",
    "groups": {
      "superAdmins": "Superadministratörer",
      "admins": "Administratörer",
      "improvementLeadersExtended": "Förbättringsledare utökad",
      "improvementLeaders": "Förbättringsledare"
    }
  },
  "activities": "Aktiviteter",
  "activityPageDescription": "Här får du en tydlig överblick över alla aktiviteter. Följ länken nedan för att skapa, redigera eller ta bort aktiviteter. Du kan även lägga till, ta bort eller ändra deras metadata.",
  "activityPageLink": "Hantera aktiviteter",
  "tagManager": "Tagghanteraren",
  "tagPageDescription": "Här får du en tydlig överblick över alla roller och navigationstaggar. Följ länken nedan för att skapa, redigera och ta bort roller/noder.",
  "tagPageLink": "Hantera taggar",
  "chapter": "Kapitel",
  "chapterPageDescription": "En listning av samtliga kapitel. Kapitel taggas upp med tillhörande samlingsrubrik och rotprocess för att visas korrekt i navigationen.",
  "chapterPageLink": "Hantera kapitel",
  "navigationProcessValidation": "Placering måste vara valt som rad eller kolumn",
  "selectField": "Välj fält",
  "createChapter": "Skapa Kapitel",
  "saveActivity": "Spara",
  "saveUpdate": "Spara uppdateringar",
  "quickEdit": "Snabbredigering",
  "searchActivity": "Sök efter aktiviteter",
  "searchChapter": "Sök efter kapitel",
  "searchTag": "Sök efter taggar",
  "title": "Rubrik",
  "modifiedBy": "Ändrades av",
  "modified": "Ändrat",
  "createdBy": "Skapad av",
  "created": "Skapad",
  "create": "Skapa",
  "editActivity": "Redigera Aktivitet",
  "back": "Tillbaka",
  "content": "Innehåll",
  "improve": "Förbättra",
  "help": "Hjälp",
  "admin": "Admin",
  "signOut": "Logga ut",
  "pageNotFound": "Sidan hittades inte!",
  "click": "klicka",
  "here": "här",
  "returnHome": "för att återvända till startsidan",
  "tagCollection": "Taggsamling",
  "loadingTagCollections": "Laddar Taggsamling...",
  "editChapter": "Redigera Kapitel",
  "loading": "Laddar",
  "delete": "Ta bort",
  "deleteActivityDraft": "Ta bort utkast",
  "deleteActivityDraftPrompt": "Är du säker på att du vill ta bort utkastet: ",
  "cancelDraft": "Avbryt utkast",
  "cancelDraftDialogTitle": "Avbryt utkast",
  "cancelDraftDialogMessage": "Vill du avbryta utkastet? Om du avbryter utkastet förlorar du alla ändringar som gjorts. Vill du avbryta?",
  "cancelDraftDialogCheckedOutTitle": "Utkastet är utcheckat till annan användare",
  "cancelDraftDialogCheckedOutMessage": "Detta utkast är utcheckat till {{user}}. Om du avbryter utkastet förloras även den användarens ändringar. Vill du fortsätta?",
  "yes": "Ja",
  "no": "Nej",
  "deleteChapter": "Ta bort kapitel",
  "deleteChapterPrompt": "Är du säker på att du vill ta bort kapitlet: ",
  "cancel": "Avbryt",
  "cancelJob": "Avbryt jobb",
  "collectionTitle": "Samlingsrubrik",
  "variant": "Kopplad till variant (Används av KMA-Pärmen)",
  "navigationNode": "Navigeringsnod",
  "saveChapter": "Spara Kapitel",
  "noMatchingTags": " Det finns inga taggar som matchar sökningen",
  "select": "Välj",
  "selectTag": "Välj tagg",
  "selectedTag": "Vald tagg",
  "selectedTags": "Valda taggar",
  "openAll": "Öppna alla",
  "openSection": "Fäll ut avsnitt",
  "closeAll": "Stäng alla",
  "treeView": "Trädvy",
  "moveTag": "Flytta tagg",
  "move": "Flytta",
  "save": "Spara",
  "saveAndPublish": "Spara och publicera",
  "saveOptionsButtonLabel": "Fler alternativ",
  "close": "Stäng",
  "loadingTags": "Laddar taggar...",
  "applicationError": "Ett fel uppstod i applikationen.",
  "reloadOrTryAgain": "Ladda om sidan eller försök igen senare.",
  "reloadPage": "Ladda om sidan",
  "tryAgain": "Försök igen",
  "someError": "Något gick fel.",
  "update": "Uppdatera",
  "export": "Exportera",
  "download:": "Ladda ner",
  "downloadOriginalFile": "Ladda ner originalfil",
  "downloadOriginalSelectedDocuments": "Ladda ner original ({{count}})",
  "exportTagCollection": "Exportera taggsamling",
  "exportDownloadPrompt": " Är du säker på att du vill ladda ner alla taggar i denna kollektionen?",
  "import": "Importera",
  "importTags": "Importera taggar",
  "structureLocation": "Plats i strukturen",
  "moveTagDialog": "vart taggen ska flyttas. Alla undertaggar följer med i flytten!",
  "copySection": "Kopiera avsnitt",
  "copySectionTo": "vart avsnittet ska kopieras. Alla undertaggar följer med i kopieringen!",
  "copyTargetDescendantError": "Det går inte att kopiera ett avsnitt till en plats under sig själv.",
  "copyTag": "Kopiera tagg",
  "copy": "Kopiera",
  "sort": "Sortera",
  "alphabeticalOrder": "Sortera i alfabetisk ordning",
  "manualSort": "Manuell sortering",
  "noChildTags": "Inga undertaggar",
  "saveSort": "Spara sortering",
  "createTag": "Skapa ny tagg",
  "createTagUnder": "Skapa ny tagg under",
  "confirmDeletion": "Bekräfta borttagning",
  "deleteTagPrompt": "Är du säker på att du vill ta bort taggen ",
  "deleteTagWarning": "Om det finns undertaggar kommer de också att tas bort!",
  "duplicateTagNameError": "Åtgärden kan inte utföras då det redan finns en nod med samma namn på denna nivå.",
  "newTag": "Ny tagg",
  "newChildTag": "Ny undertagg",
  "moreOptions": "Fler alternativ",
  "activityDescription": "Skriv innehållet här ...",
  "textFormat": "Textformat",
  "changeTextFormat": "Ändra textformat",
  "paragraph": "Stycke",
  "heading2": "Rubrik 2",
  "heading3": "Rubrik 3",
  "heading4": "Rubrik 4",
  "collapseHeadingTooltipLabelDefaultOpen": "Kollapsad rubrik (Standard Öppen)",
  "collapseHeadingTooltipLabelDefaultClosed": "Kollapsad rubrik (Standard Stängd)",
  "bold": "Fet stil",
  "italic": "Kursiv",
  "underline": "Understryka",
  "strikethrough": "Genomstryka",
  "subscript": "Nedsänkt",
  "superscript": "Upphöjt",
  "textColor": "Textfärg",
  "highlightColor": "Markeringsfärg",
  "link": "Länk",
  "align": "Justera",
  "orderedList": "Numrerad lista",
  "bulletedList": "Punktlista",
  "blockquote": "Blockcitat",
  "uploadImage": "Ladda upp bild",
  "upload": "Ladda upp",
  "insertHorizontalRule": "Infoga horisontell linje",
  "insertTable": "Infoga tabell",
  "tableStyles": "Tabellstilar",
  "tableStyle": "Tabellstil",
  "defaultTable": "Standard tabell",
  "transparentTable": "Transparent tabell",
  "warningTable": "Notistabell",
  "tableWidth": "Tabellbredd",
  "exactWidth": "Exakt bredd",
  "widthHelperText": "Ange 1-100% och tryck Enter",
  "current": "Nuvarande",
  "tableResize": "Ändra tabellstorlek",
  "tableResizeControls": "Kontroller för tabellstorlek",
  "selectTableToResize": "Välj en tabellcell för att komma åt storlekskontroller",
  "cellWidth": "Cellbredd",
  "cellHeight": "Cellhöjd",
  "apply": "Tillämpa",
  "cellResizeHelp": "Ange bredd för den valda cellen. Min bredd: 25px",
  "cellHeightHelp": "Ange höjd för den valda cellen. Min höjd: 25px",
  "withHeader": "med rubrik",
  "removeInlineFormatting": "Ta bort inbäddad formatering",
  "undo": "Ångra",
  "redo": "Gör om",
  "indent": "Indrag",
  "unindent": "Ta bort indrag",
  "highlight": "Markera",
  "chooseThumbnail": "Välj omslagsbild",
  "uploadThumbnail": "Ladda upp ny omslagsbild",
  "preview": "Förhandsgranskning",
  "publish": "Publicera",
  "publishDialogTitle": "Publicera aktivitet",
  "drafts": "Utkast",
  "published": "Publicerade",
  "archivedListTab": "Arkiverade",
  "publishedActivities": "Publicerade aktiviteter",
  "process": "Process",
  "selectFile": "Välj fil",
  "tool": "Hjälpmedel",
  "media": "Media",
  "mediaPageLink": "Hantera filer",
  "showFiles": "Visa filer",
  "mediaPageDescription": "Här kan du hantera bilder som sedan går att användas av aktiviteter och kapitel.",
  "chapterImages": "Kapitelbilder",
  "activityImages": "Aktivitetsbilder",
  "deleteImagePrompt": "Är du säker på att du vill ta bort bilden: ",
  "files": "Filer",
  "filesPageDescription": "Här kan du ladda upp och hantera filer som sedan går att användas av aktiviteter.",
  "deleteToolPrompt": "Är du säker på att du vill ta bort filen: ",
  "filePageLink": "Hantera filer",
  "correlationIdLabel": "Korrelations-ID: ",
  "documentsPageDescription": "Här kan du skapa och redigera hjälpmedelsdokument.",
  "documentsPageLink": "Hantera dokument",
  "linksPageDescription": "Här kan du skapa och redigera hjäpmedelslänkar.",
  "linksPageLink": "Hantera länkar",
  "links": "Länkar",
  "createNew": "Skapa nytt",
  "createTool": "Skapa utkast",
  "edit": "Redigera",
  "editTool": "Redigera hjälpmedel",
  "saveTool": "Spara hjälpmedel",
  "createLinkTool": "Skapa länk",
  "createDocumentTool": "Skapa dokument",
  "document": "Dokument",
  "giveToolTitle": "Ge hjälpmedlet en titel",
  "url": "URL",
  "enterToolUrl": "Ange hjälpmedlets URL",
  "adminDisplayNameLabel": "Namn",
  "adminDisplayNameHint": "Detta är ett internt namn. Det kommer inte att visas för slutanvändare.",
  "chooseFile": "Välj fil",
  "selectTool": "Välj hjälpmedel",
  "editDocumentTool": "Redigera dokument",
  "editLinkTool": "Redigera länk",
  "searchTool": "Sök hjälpmedel...",
  "noResults": "Inga resultat",
  "hideRevisionCheckboxLabel": "Göm kommentar för slutanvändare",
  "publishAsPdfCheckboxLabel": "Publicera som PDF",
  "commentLabel": "Kommentar",
  "publishingDescription": "Du håller på att publicera en aktivitet. Om aktiviteten är satt som aktiv så kommer den nu bli tillgänglig för slutanvändare.",
  "booleanFieldValueTrue": "Ja",
  "booleanFieldValueFalse": "Nej",
  "showHistory": "Visa historik",
  "history": "Historik",
  "version": "Version",
  "comments": "Revideringskommentar",
  "activate": "Aktivera",
  "deactivate": "Avaktivera",
  "activateActivityDialogTitle": "Aktivera aktivitet",
  "deactivateActivityDialogTitle": "Avaktivera aktivitet",
  "activateActivityDescription": "Du håller på att aktivera en aktivitet. Detta gör aktiviteten tillgänglig för slutanvändare.",
  "deactivateActivityDescription": "Du håller på att avaktivera en aktivitet. Detta gör att aktiviteten slutar vara tillgänglig för slutanvändare.",
  "deactivateActivityWithSubActivitiesTitle": "Varning: Aktiviteten har underaktiviteter",
  "deactivateActivityWithSubActivitiesMessage": "Inaktivering kan inte genomföras då aktiviteten har underaktiviteter.",
  "deactivateActivityWithMirroredChildrenTitle": "Varning: Aktiviteten är källaktivitet",
  "deactivateActivityWithMirroredChildrenMessage": "Inaktivering kan inte genomföras då aktiviteten är en källaktivitet för speglade aktiviteter.",
  "oldVersion": "Äldre version",
  "oldVersionMessageBarTextActivity": "Detta är en äldre version av aktiviteten och representerar därför inte vad slutanvändare ser idag. Du hittar den senaste versionen här: ",
  "publishedBy": "Publicerad av",
  "publishedDate": "Publicerat",
  "toDraft": "Till utkast",
  "mirroredActivityWarningMessage": "Detta är en speglad aktivitet. <Link>Klicka här</Link> för att navigera till redigering av källaktiviteten.",
  "mirrorActivity": "Spegla aktivitet",
  "mirrorChildrenList": "Aktiviteten har {{mirroredChildrenCount}} speglingar på följande placeringar:",
  "sharedActivityChaptersList": "Aktiviteten har följande placeringar:",
  "mirroredActivitySharedTooltip": "Speglingens placeringar",
  "demirrorActivity": "Avspegla aktivitet",
  "inactive": "Inaktiv",
  "imageActive": "Aktiv",
  "imageUsedInPublishedActivitiesTitle": "Bilden används i publicerade aktiviteter",
  "imageUsedInPublishedActivitiesMessage": "Bilden används i en eller flera publicerade aktiviteter och kan därför inte markeras som utgången.",
  "continueButton": "Fortsätt",
  "unsavedChangesMessage": "Du har osparade ändringar. Vill du verkligen lämna sidan?",
  "note": "Observera! ",
  "publishedTool": "Publicerade hjälpmedel",
  "currentDocument": "Aktuellt dokument",
  "changeDocument": "Ersätt dokument",
  "publishDraftDialogTitle": "Publicera hjälpmedel",
  "publishDraftDescription": "Du håller på att publicera ett hjälpmedel. Om hjälpmedlet är satt som aktiv så kommer det nu bli tillgänglig för slutanvändare.",
  "publishFileValidationError": "Dokumentfilen kunde inte hittas i SharePoint. Den kan ha tagits bort eller blivit korrupt. Vänligen ersätt filen innan du publicerar.",
  "publishError": "Ett fel uppstod vid publicering. Försök igen.",
  "deleteToolDraft": "Ta bort hjälpmedelsutkast",
  "deleteToolDraftPrompt": "Är du säker på att du vill ta bort hjälpmedelsutkastet: ",
  "oldVersionMessageBarTextTool": "Detta är en äldre version av hjälpmedlet och representerar därför inte vad slutanvändare ser idag. Du hittar den senaste versionen här:",
  "activitySectionTags": "Taggar",
  "activitySectionTools": "Hjälpmedel",
  "activitySectionProcessFlow": "Aktivitetsflöde",
  "processFlow": {
    "inheritance": {
      "label": "Arv från avsnittets huvudnod",
      "yes": "Ja",
      "no": "Nej"
    },
    "visibility": {
      "label": "Visa aktivitetsflöde",
      "enabled": "Aktiviteten ska ha ett aktivitetsflöde",
      "currentLevel": "Visa endast underprocess",
      "currentAndChild": "Visa aktivitetsflöde",
      "hidden": "Inget aktivitetsflöde"
    },
    "connection": {
      "label": "Koppling",
      "none": "Ingen",
      "arrow": "Pil"
    },
    "activityShape": {
      "label": "Form (aktivitetsbubbla)",
      "rectangle": "Rektangel",
      "hidden": "Ingen (göms i flöde)"
    },
    "head": {
      "label": "Aktivera som huvudnod",
      "activationLabel": "Aktivera aktivitetsflöde",
      "yes": "Ja",
      "no": "Nej",
      "defaultShapeLabel": "Standardform",
      "defaultConnectionLabel": "Standardkoppling"
    },
    "selectProcessMessage": "Välj en process under Taggar för att ändra aktivitetsflödet.",
    "showArrowToNextStep": "Visa pil till nästa steg"
  },
  "activityToolsTable": {
    "heading": "Kopplade hjälpmedel",
    "actions": "Åtgärder",
    "createDraft": "Skapa utkast"
  },
  "activityPreviewLabel": "Förhandsgranskning",
  "activityPreviewPlaceholder": "Här kan du förhandsgranska innehållet från innehållseditorn till vänster.",
  "cancelSelectedNewFile": "Avbryt val av ny dokument",
  "newSelectedFile": "Ny vald fil",
  "activityId": "ID",
  "versionId": "Versions id",
  "activitiesUsingThisTool": "Aktiviteter som använder hjälpmedlet: ",
  "noActivitiesUsingThisTool": "Inga aktiviteter använder detta hjälpmedel!",
  "activity": "Aktivitet",
  "type": "Typ",
  "name": "Namn",
  "adminStart": "Admin start",
  "adminBreadcrumb": "Admin breadcrumb",
  "searchName": "Sök namn",
  "showActivity": "Visa aktivitet",
  "showActivities": "Visa aktiviteter",
  "toolSectionTags": "Taggar",
  "activateToolDialogTitle": "Aktivera hjälpmedel",
  "deactivateToolDialogTitle": "Avaktivera hjälpmedel",
  "activateToolDescription": "Du håller på att aktivera ett hjälpmedel. Detta gör hjälpmedlet tillgängligt för slutanvändare.",
  "deactivateToolDescription": "Du håller på att avaktivera ett hjälpmedel. Detta gör att hjälpmedlet slutar vara tillgängligt för slutanvändare.",
  "duplicateFileNameError": "Det finns redan en fil med samma namn. Ändra filnamnet och försök igen.",
  "addTool": "Lägg till hjälpmedel",
  "invalidUrlErrorMsg": "Felaktig url angiven. Har du inkluderat http:// eller https://?",
  "processInUse": "Används av annan aktivitet",
  "systemAdminPage": "Systemadmin",
  "reindex": "Omindexera sök",
  "reindexPrompt": "Detta kommer att omindexera alla aktiviteter och hjälpmedel. Är du säker på att du vill fortsätta?",
  "reindexStarted": "Omindexeringsjobb har startats",
  "reindexRedirectMessage": "Omindexering startad",
  "reindexError": "Fel vid start av omindexering",
  "reindexErrors": {
    "jobAlreadyRunning": "Ett omindexeringsjobb körs redan. Vänligen vänta tills det är klart.",
    "failedToStart": "Kunde inte starta omindexeringsjobbet. Försök igen senare.",
    "unknown": "Ett okänt fel uppstod vid start av omindexering."
  },
  "reindexStatusMonitoring": "Jobstatus",
  "reindexMonitoring": {
    "title": "Omindexeringsövervakning",
    "backToAdmin": "Tillbaka till admin",
    "loading": "Laddar jobbstatus...",
    "errorLoadingStatus": "Kunde inte ladda jobbstatus",
    "currentJobStatus": "Aktuell jobbstatus",
    "noActiveJob": "Inget aktivt omindexeringsjobb",
    "jobId": "Jobb-ID",
    "startTime": "Starttid",
    "endTime": "Sluttid",
    "duration": "Varaktighet",
    "startNewJob": "Starta nytt omindexeringsjobb",
    "starting": "Startar jobb...",
    "currentJobTab": "Aktuellt jobb",
    "historyTab": "Jobbhistorik",
    "inProgress": "Pågår",
    "progress": "Procent klart",
    "update": "Uppdatera"
  },
  "reindexStatus": {
    "notStarted": "Inte startat",
    "running": "Kör",
    "completed": "Klart",
    "failed": "Misslyckades",
    "canceled": "Avbrutet"
  },
  "reindexStep": {
    "starting": "Startar",
    "processingActivities": "Behandlar aktiviteter",
    "processingTools": "Behandlar hjälpmedel",
    "processingImages": "Behandlar bilder",
    "processingChapters": "Behandlar kapitel",
    "finalizing": "Slutför",
    "completed": "Klar"
  },
  "reindexProgress": {
    "stepProgress": "Steg {{current}} av {{total}}",
    "documentsProcessed": "{{processed}} av {{total}} dokument behandlade"
  },
  "reindexActivityLog": {
    "title": "Aktivitetslogg",
    "noActivities": "Inga aktiviteter att visa",
    "documents": "dokument",
    "items": "objekt"
  },
  "failedDocuments": {
    "title": "Misslyckade dokument",
    "noFailedDocuments": "Inga misslyckade dokument",
    "name": "Namn",
    "type": "Typ",
    "error": "Fel",
    "timestamp": "Tidsstämpel"
  },
  "reindexHistory": {
    "title": "Jobbhistorik",
    "loading": "Laddar historik...",
    "errorLoading": "Fel vid laddning av historik",
    "noHistory": "Ingen jobbhistorik tillgänglig",
    "jobId": "Jobb-ID",
    "status": "Status",
    "startTime": "Starttid",
    "duration": "Varaktighet",
    "totalDocuments": "Totalt antal dokument",
    "failedDocuments": "Misslyckade dokument",
    "error": "Fel",
    "inProgress": "Pågår",
    "totalItems": "Totalt antal objekt"
  },
  "selectFileErrorMessage": "Vänligen välj en fil innan du laddar upp",
  "largeImageErrorMessage": "Bilden är för stor (bredd: {{width}}px höjd: {{height}}px). Vänligen ladda up en bild som har dimensionerna bredd: {{maxWidth}}px och höjd: {{maxHeight}}px",
  "clearCache": "Rensa cache",
  "clearCachePrompt": "Detta kommer att rensa Vsaa apiets cache. Är du säker på att du vill fortsätta?",
  "roles": "Roller",
  "rolesPageDescription": "Här kan du hantera roller som används i aktiviteter och hjälpmedel.",
  "rolesPageLink": "Hantera roller",
  "toolId": "ID",
  "mirroredActivity": "Speglad aktivitet",
  "systemAdminPageDescription": "Här finns funktioner som används för att underhålla systemet.",
  "reportsPage": {
    "title": "Rapporter",
    "flatTitle": "Testrapporter - En rad per objekt",
    "description": "Ladda ner administrativa rapporter.",
    "link": "Visa rapporter",
    "publishedActivities": "Aktiviteter - Publicerade",
    "draftActivities": "Aktiviteter - Utkast",
    "publishedDocuments": "Dokument - Publicerade",
    "draftDocuments": "Dokument - Utkast",
    "publishedLinks": "Länkar - Publicerade",
    "draftLinks": "Länkar - Utkast",
    "publishedActivityImages": "Aktivitetsbilder - Publicerade",
    "draftActivityImages": "Aktivitetsbilder - Utkast"
  },
  "documentLinksReport": {
    "title": "Dokument som innehåller länkar",
    "download": "Ladda ner rapport"
  },
  "cacheManagement": {
    "title": "Cachehantering",
    "description": "Rensa API-cache eller bygg om navigationscachen.",
    "link": "Hantera cache"
  },
  "reindexManagement": {
    "title": "Omindexering",
    "description": "Starta och övervaka omindexeringsjobb för sök.",
    "link": "Hantera omindexering"
  },
  "publishedDocumentMetadataMigration": {
    "title": "Migrering av dokumentmetadata",
    "description": "Flytta publicerad SharePoint-metadata till hjälpmedelsversioner.",
    "manage": "Hantera migrering",
    "back": "Tillbaka till Systemadmin",
    "start": "Starta",
    "cancel": "Avbryt",
    "export": "Exportera undantag",
    "retry": "Försök undantag igen",
    "resume": "Återuppta",
    "close": "Stäng",
    "confirmAction": "Bekräfta",
    "loading": "Hämtar migreringsstatus...",
    "empty": "Ingen migrering har startats i den här webbläsaren.",
    "offline": "Du är offline. Senast hämtad status visas.",
    "workerDisabled": "Migreringsarbetaren är inte aktiverad. Startade migreringar kommer inte att bearbetas.",
    "loadError": "Status kunde inte hämtas. Senast hämtad status behålls.",
    "startError": "Migreringen kunde inte startas. Försök igen.",
    "cancelError": "Migreringen kunde inte avbrytas. Försök igen.",
    "downloadError": "Undantagen kunde inte laddas ner. Försök igen.",
    "correlationId": "Referens-ID:",
    "stale": "Statusen är äldre än 15 sekunder.",
    "status": "Status",
    "jobId": "Jobb-ID",
    "started": "Startad",
    "heartbeat": "Senaste livstecken",
    "page": "Sida",
    "scanned": "Kontrollerade",
    "updated": "Uppdaterade",
    "skipped": "Överhoppade",
    "missing": "Saknade filer",
    "ambiguous": "Tvetydiga träffar",
    "exceptions": "Undantag",
    "conflicts": "Konflikter",
    "finished": "Avslutad",
    "progress": "Migreringsförlopp",
    "states": {
      "pending": "Väntar",
      "running": "Pågår",
      "cancelling": "Avbryts",
      "cancelled": "Avbruten",
      "completed": "Slutförd",
      "completedWithExceptions": "Slutförd med undantag",
      "failed": "Misslyckad"
    },
    "confirm": {
      "start": {
        "title": "Starta migrering",
        "body": "Migreringen körs i bakgrunden och kan följas på den här sidan."
      },
      "cancel": {
        "title": "Avbryt migrering",
        "body": "Bearbetningen stoppas efter pågående arbete."
      }
    }
  },
  "publishedMediaMetadataMigration": {
    "title": "Migrering av mediemetadata",
    "description": "Flytta metadata för publicerade medier från SharePoint till medieversioner.",
    "manage": "Hantera migrering",
    "back": "Tillbaka till Systemadmin",
    "start": "Starta",
    "cancel": "Avbryt",
    "export": "Exportera undantag",
    "retry": "Försök undantag igen",
    "resume": "Återuppta",
    "close": "Stäng",
    "confirmAction": "Bekräfta",
    "loading": "Hämtar migreringsstatus...",
    "empty": "Ingen mediemigrering har startats i den här webbläsaren.",
    "offline": "Du är offline. Senast hämtad status visas.",
    "workerDisabled": "Migreringsarbetaren är inte aktiverad. Startade migreringar kommer inte att bearbetas.",
    "loadError": "Status kunde inte hämtas. Senast hämtad status behålls.",
    "startError": "Mediemigreringen kunde inte startas. Försök igen.",
    "cancelError": "Mediemigreringen kunde inte avbrytas. Försök igen.",
    "downloadError": "Undantagen kunde inte laddas ner. Försök igen.",
    "correlationId": "Referens-ID:",
    "stale": "Statusen är äldre än 15 sekunder.",
    "failedMessage": "Migreringen misslyckades. Använd referens-ID och serverloggar vid felsökning.",
    "status": "Status",
    "jobId": "Jobb-ID",
    "started": "Startad",
    "heartbeat": "Senaste livstecken",
    "page": "Sida",
    "scanned": "Kontrollerade",
    "updated": "Uppdaterade",
    "skipped": "Överhoppade",
    "fileMissing": "Saknade filer",
    "ambiguous": "Tvetydiga träffar",
    "exceptions": "Undantag",
    "conflicts": "Konflikter",
    "finished": "Avslutad",
    "progress": "Migreringsförlopp",
    "states": {
      "pending": "Väntar",
      "running": "Pågår",
      "cancelling": "Avbryts",
      "cancelled": "Avbruten",
      "completed": "Slutförd",
      "completedWithExceptions": "Slutförd med undantag",
      "failed": "Misslyckad"
    },
    "confirm": {
      "start": {
        "title": "Starta mediemigrering",
        "body": "Migreringen körs i bakgrunden och kan följas på den här sidan."
      },
      "cancel": {
        "title": "Avbryt mediemigrering",
        "body": "Bearbetningen stoppas efter pågående arbete."
      }
    }
  },
  "imageFileMigration": {
    "title": "Migrering av bildfiler",
    "description": "Granska och migrera filer för publicerade bildversioner.",
    "manage": "Hantera migrering",
    "back": "Tillbaka till Systemadmin",
    "dryRun": "Testkörning (inga ändringar)",
    "dryRunMode": "Testkörning",
    "liveMode": "Skarp körning",
    "mode": "Körläge",
    "start": "Starta",
    "cancel": "Avbryt",
    "resume": "Återuppta",
    "retry": "Försök undantag igen",
    "close": "Stäng",
    "confirmAction": "Bekräfta",
    "confirmLive": "Bekräfta skarp körning",
    "loading": "Hämtar migreringsstatus...",
    "empty": "Ingen bildfilmigrering har startats i den här webbläsaren.",
    "offline": "Du är offline. Senast hämtad status visas.",
    "loadError": "Status kunde inte hämtas. Försök igen senare.",
    "missingJob": "Det sparade migreringsjobbet finns inte längre. Glöm jobbet för att starta en ny körning.",
    "forgetJob": "Glöm sparat jobb",
    "startError": "Bildfilmigreringen kunde inte startas. Försök igen.",
    "cancelError": "Bildfilmigreringen kunde inte avbrytas. Försök igen.",
    "failedMessage": "Migreringen misslyckades. Kontakta supporten med jobb-ID vid felsökning.",
    "status": "Status",
    "jobId": "Jobb-ID",
    "started": "Startad",
    "heartbeat": "Senaste livstecken",
    "page": "Sida",
    "scanned": "Kontrollerade",
    "updated": "Uppdaterade",
    "skipped": "Överhoppade",
    "fileMissing": "Saknade filer",
    "ambiguous": "Tvetydiga träffar",
    "exceptions": "Undantag",
    "conflicts": "Konflikter",
    "finished": "Avslutad",
    "progress": "Migreringsförlopp",
    "report": "Undantagsrapport",
    "versionId": "Versions-ID",
    "errorCode": "Felkod",
    "message": "Meddelande",
    "occurred": "Tidpunkt",
    "states": {
      "pending": "Väntar",
      "running": "Pågår",
      "cancelling": "Avbryts",
      "cancelled": "Avbruten",
      "completed": "Slutförd",
      "completedWithExceptions": "Slutförd med undantag",
      "failed": "Misslyckad"
    },
    "confirm": {
      "start": {
        "title": "Starta bildfilmigrering",
        "body": "Migreringen körs i bakgrunden och kan följas här."
      },
      "resume": {
        "title": "Återuppta bildfilmigrering",
        "body": "Bearbetningen fortsätter från det valda jobbet."
      },
      "retry": {
        "title": "Försök undantag igen",
        "body": "Undantagen från det valda jobbet bearbetas igen."
      },
      "cancel": {
        "title": "Avbryt bildfilmigrering",
        "body": "Bearbetningen stoppas efter pågående arbete."
      },
      "dryRun": "Inga filer eller metadata ändras under testkörningen.",
      "live": "Detta är en skarp körning som ändrar filer och metadata. Bekräfta för att fortsätta."
    }
  },
  "imageMetadataUpdater": {
    "title": "Uppdatera bildmetadata",
    "description": "Uppdatera filstorlek och bilddimensioner för publicerade bilder.",
    "manage": "Öppna uppdatering",
    "back": "Tillbaka till Systemadmin",
    "start": "Starta uppdatering",
    "pending": "Uppdatering pågår...",
    "success": "Bildmetadata har uppdaterats.",
    "error": "Bildmetadata kunde inte uppdateras. Försök igen.",
    "cancel": "Avbryt",
    "confirmAction": "Bekräfta",
    "confirm": {
      "title": "Starta uppdatering av bildmetadata",
      "body": "Uppdateringen körs nu."
    }
  },
  "searchSettingsManagement": {
    "description": "Konfigurera globala sökinställningar och filter.",
    "link": "Hantera sökinställningar"
  },
  "documentManagement": {
    "title": "Dokumenthantering",
    "description": "Sök efter dokument och hantera borttagning från databasen.",
    "link": "Hantera dokument",
    "searchLabel": "Sök dokument",
    "searchPlaceholder": "Sök på titel eller ID...",
    "search": "Sök",
    "select": "Välj",
    "documentInfo": "Dokumentinformation",
    "toolId": "Hjälpmedels-ID",
    "url": "URL",
    "adminName": "Adminnamn",
    "fileStatus": "Filstatus",
    "fileValid": "Fil giltig",
    "fileInvalid": "Fil saknas/korrupt",
    "deleteDocument": "Ta bort dokument",
    "deleteDialogTitle": "Ta bort dokument permanent",
    "deleteDialogMessage": "Du håller på att permanent ta bort dokumentet \"{{title}}\" och alla dess versioner från databasen. Denna åtgärd kan inte ångras.",
    "deleteCommentLabel": "Kommentar för revisionsloggen",
    "deleteCommentPlaceholder": "Ange anledning till borttagning...",
    "confirmDelete": "Bekräfta borttagning",
    "deleteSuccess": "Dokument borttaget",
    "deleteSuccessMessage": "Dokumentet \"{{title}}\" har tagits bort permanent.",
    "deleteError": "Kunde inte ta bort dokumentet. Försök igen.",
    "error": "Fel",
    "noResults": "Inga dokument hittades för \"{{query}}\"",
    "relinkError": "Kunde inte koppla om dokumentet. Försök igen.",
    "tabs": {
      "search": "Dokumentsökning",
      "health": "Hälsokontroll"
    },
    "health": {
      "startScan": "Starta scanning",
      "scanning": "Skannar...",
      "library": "SharePoint-bibliotek",
      "fileUniqueId": "Fil-ID",
      "url": "Länk",
      "toolId": "ID",
      "versionId": "Versionsid",
      "addFile": "Lägg till fil",
      "relinkDialogTitle": "Lägg till fil",
      "relinkDialogMessage": "Välj vilken fil utan hjälpmedel som ska kopplas om till \"{{title}}\".",
      "newFileUniqueIdLabel": "Välj fil utan hjälpmedel",
      "newFileUniqueIdPlaceholder": "Välj en fil från listan...",
      "confirmRelink": "Bekräfta omkoppling",
      "noOrphanFilesForRelink": "Inga filer utan hjälpmedel är tillgängliga för omkoppling.",
      "relinkSuccess": "Fil-ID för \"{{title}}\" har uppdaterats.",
      "relinkError": "Misslyckades med att koppla om filen.",
      "missingFileTitle": "Hjälpmedel utan fil",
      "noMissingFiles": "Inga hjälpmedel saknar fil.",
      "noResults": "Ingen scanning har slutförts ännu. Starta en scanning för att se resultat.",
      "orphanFileTitle": "Filer utan hjälpmedel",
      "noOrphanFiles": "Inga filer saknas i databasen.",
      "linkToDraft": "Koppla till utkast",
      "linkToDraftDialogTitle": "Koppla fil till utkast",
      "linkToDraftDialogMessage": "Sök fram och välj det dokument som den lösa filen ska kopplas till som ett nytt utkast.",
      "selectedOrphanFile": "Vald fil utan hjälpmedel",
      "searchDocumentToLink": "Sök dokument att koppla till",
      "searchDocumentPlaceholder": "Sök på dokumenttitel eller ID...",
      "selectedDocument": "Valt dokument",
      "changeSelectedDocument": "Byt dokument",
      "hasDraftWarning": "Dokumentet har redan ett aktivt utkast. Det går inte att skapa ett nytt utkast eftersom befintliga ändringar då skulle skrivas över.",
      "noDraftInfo": "Dokumentet har inget aktivt utkast. Ett nytt utkast kommer att skapas baserat på detta dokument med den valda filen kopplad.",
      "linkAndCreateDraft": "Koppla och skapa utkast",
      "linkToDraftSuccess": "Ett nytt utkast har skapats och filen har kopplats för \"{{title}}\".",
      "linkToDraftError": "Kunde inte skapa utkast och koppla filen. Försök igen.",
      "checkingDraftStatus": "Kontrollerar utkaststatus...",
      "tabs": {
        "current": "Senaste resultat",
        "history": "Historik"
      },
      "status": {
        "Pending": "Väntar",
        "Running": "Körs",
        "Completed": "Klar",
        "Failed": "Misslyckades",
        "Cancelled": "Avbruten"
      },
      "history": {
        "title": "Körbeskrivning",
        "noHistory": "Ingen historik finns ännu.",
        "startTime": "Starttid",
        "status": "Status",
        "missingFiles": "Hjälpmedel utan fil",
        "orphanFiles": "Filer utan hjälpmedel",
        "triggeredBy": "Startad av",
        "triggeredByCron": "Schemalagd"
      }
    }
  },
  "linkManagement": {
    "title": "Länkhantering",
    "description": "Sök efter länkar och hantera borttagning från databasen.",
    "link": "Hantera länkar",
    "searchLabel": "Sök länk",
    "searchPlaceholder": "Sök på titel eller ID...",
    "search": "Sök",
    "linkInfo": "Länkinformation",
    "toolId": "Hjälpmedels-ID",
    "url": "URL",
    "adminName": "Adminnamn",
    "deleteLink": "Ta bort länk",
    "deleteDialogTitle": "Ta bort länk permanent",
    "deleteDialogMessage": "Du håller på att permanent ta bort länken \"{{title}}\" och alla dess versioner från databasen. Denna åtgärd kan inte ångras.",
    "deleteCommentLabel": "Kommentar för revisionsloggen",
    "deleteCommentPlaceholder": "Ange anledning till borttagning...",
    "confirmDelete": "Bekräfta borttagning",
    "deleteSuccess": "Länk borttagen",
    "deleteSuccessMessage": "Länken \"{{title}}\" har tagits bort permanent.",
    "deleteError": "Kunde inte ta bort länken. Försök igen.",
    "error": "Fel",
    "noResults": "Inga länkar hittades för \"{{query}}\""
  },
  "chapters": "Kapitel",
  "documentHealthCheck": {
    "title": "Hälsoövervakning – dokument",
    "backToDocumentManagement": "Tillbaka till Dokumenthantering",
    "refresh": "Uppdatera",
    "latestJobStatus": "Senaste jobbstatus",
    "noJobYet": "Ingen scanning har körts än. Starta en scanning för att se resultat.",
    "startTime": "Starttid",
    "endTime": "Sluttid",
    "duration": "Varaktighet",
    "progress": "Förlopp",
    "findings": "Resultat",
    "findingsSummary": "{{missing}} hjälpmedel utan fil, {{orphans}} filer utan hjälpmedel",
    "resultsTab": "Resultat",
    "historyTab": "Historik",
    "viewResults": "Visa resultat",
    "viewingHistoricalRun": "Visar resultat från körning: {{date}}",
    "showLatest": "Visa senaste",
    "historyLoadError": "Kunde inte läsa historik. Försök igen."
  },
  "active": "Aktuell",
  "checkedOutToMessageBarText": "Detta utkast är utcheckat till: ",
  "checkedOutToMessageBarTitle": "Utcheckat till annan användare",
  "graphAuthenticationError": "Graph autentiseringsfel",
  "graphClientNotAvailable": "Graph klient inte tillgänglig",
  "searchFilterPicker": {
    "includeChapters": "Aktivera filter på kapitel",
    "addFilter": "Lägg till filter",
    "addFilterDropdownPlaceholder": "Välj fält att lägga till som filter",
    "includeAllOptions": "Inkludera alla alternativ"
  },
  "saveGlobalSearchSettings": "Spara sökfiltreringsinställningar",
  "globalSearchSettingsHeader": "Globala sökinställningar",
  "massPublish": "Publicera markerade utkast",
  "massPublishDialogTitle": "Masspublicera aktiviteter",
  "massPublishCount": "Publicerar {{count}} aktiviteter",
  "massPublishingDescription": "Du håller på att publicera de valda aktiviteterna. Vänligen ange en kommentar som kommer att tillämpas på alla aktiviteter.",
  "massPublishingDescriptionQuickEdit": "Du håller på att publicera de valda aktiviteterna från snabbredigeringsläget. Vänligen ange en kommentar som kommer att tillämpas på alla aktiviteter.",
  "massPublishToolDialogTitle": "Masspublicera hjälpmedel",
  "massPublishToolCount": "Publicerar {{count}} hjälpmedel",
  "massPublishToolDescription": "Du håller på att publicera de valda hjälpmedlen. Vänligen ange en kommentar som kommer att tillämpas på alla hjälpmedel.",
  "massPublishResultsTitle": "Masspubliceringsresultat",
  "massPublishErrorTitle": "Fel",
  "massPublishGeneralError": "Misslyckades att publicera aktiviteter. Försök igen.",
  "massPublishSummary": "{{successful}} lyckades, {{failed}} misslyckades, {{total}} totalt",
  "massPublishItemSuccess": "Publicerad framgångsrikt: {{title}}",
  "massPublishItemError": "Misslyckades att publicera {{title}}: {{error}}",
  "massPublishActivityProcessConflict": "En eller flera processer används redan av en annan aktivitet.",
  "massPublishToolResultsTitle": "Masspubliceringsresultat för hjälpmedel",
  "massPublishToolErrorTitle": "Fel",
  "massPublishToolGeneralError": "Misslyckades att publicera hjälpmedel. Försök igen.",
  "massPublishToolSummary": "{{successful}} lyckades, {{failed}} misslyckades, {{total}} totalt",
  "massPublishToolItemSuccess": "Publicerad framgångsrikt: {{title}}",
  "massPublishToolItemError": "Misslyckades att publicera {{title}}: {{error}}",
  "massPublishImageDialogTitle": "Masspublicera media",
  "massPublishImageCount": "Publicerar {{count}} mediafiler",
  "massPublishImageDescription": "Du håller på att publicera de valda mediafilerna. Vänligen ange en kommentar som kommer att tillämpas på alla mediafiler.",
  "massPublishImageResultsTitle": "Masspubliceringsresultat för media",
  "massPublishImageErrorTitle": "Fel",
  "massPublishImageGeneralError": "Misslyckades att publicera media. Försök igen.",
  "massPublishImageSummary": "{{successful}} lyckades, {{failed}} misslyckades, {{total}} totalt",
  "massPublishImageItemSuccess": "Publicerad framgångsrikt: {{title}}",
  "massPublishImageItemError": "Misslyckades att publicera {{title}}: {{error}}",
  "quickEditSelected": "Snabbredigera valda objekt",
  "quickEditDiscardChangesMessage": "Du har osparade ändringar i snabbredigeringen. Vill du stänga utan att spara?",
  "quickEditSingleValueRequired": "Välj högst ett värde för {{field}} innan du sparar.",
  "massCreateDraftResultsTitle": "Resultat: Skapa utkast",
  "massCreateDraftSummary": "{{successful}} lyckades, {{failed}} misslyckades, {{total}} totalt",
  "massCreateDraftItemSuccess": "Utkast skapat: {{title}}",
  "massCreateDraftItemError": "Misslyckades att skapa utkast: {{error}}",
  "massCreateDraftErrorTitle": "Fel",
  "massCreateDraftGeneralError": "Misslyckades att skapa utkast. Försök igen.",
  "untitledActivity": "Aktivitet utan titel",
  "untitledImage": "Media utan titel",
  "untitledTool": "Hjälpmedel utan titel",
  "unknownError": "Okänt fel",
  "errorCode": "Felkod",
  "createChapterImage": "Skapa kapitelbild",
  "createActivityImage": "Skapa utkast",
  "searchImage": "Sök bild...",
  "uploadActivityImage": "Ladda upp aktivitetsbild",
  "uploadChapterImage": "Ladda upp kapitelbild",
  "fileSize": "Filstorlek",
  "imageDimensions": "Bildstorlek (B x H)",
  "imageCaption": "Bildtext (RollOver-text)",
  "imageId": "ID",
  "enterImageTitle": "Ange bildens titel",
  "fileName": "Namn",
  "enterImageFileName": "Ange bildens filnamn",
  "file": "Fil",
  "invalidFileNameChars": "Filnamnet innehåller ogiltiga tecken. Undvik: ~ \" # % & * : < > ? / \\ { | }",
  "fileNameSpaces": "Filnamnet får inte börja eller sluta med mellanslag",
  "fileNamePeriods": "Filnamnet får inte börja eller sluta med punkter",
  "fileNameTooLong": "Filnamnet får inte överstiga 255 tecken",
  "reservedFileName": "\"{{fileName}}\" är ett reserverat filnamn i SharePoint",
  "invalidFileType": "Endast bildfiler är tillåtna för kapitel",
  "failedToReadImage": "Misslyckades att läsa bildmått",
  "selectedFile": "Vald fil",
  "imageTitleHint": "Kommer även användas som roll over text för bilden",
  "fileNameHint": "Använd bokstäver, siffror, understreck och bindestreck. Undvik mellanslag och specialtecken.",
  "currentImage": "Aktuell bild",
  "editChapterImage": "Redigera kapitelbild",
  "editActivityImage": "Redigera aktivitetsbild",
  "fileNameAlreadyExists": "En bild med detta filnamn finns redan. Vänligen välj ett annat filnamn.",
  "newFile": "Ny fil",
  "fileNameNoDots": "Filnamnet får inte innehålla punkter",
  "publishDraftImageDialogTitle": "Publicera bildutkast",
  "publishDraftImageDescription": "Du håller på att publicera en bild. Bilden kommer nu bli tillgänglig för slutanvändare.",
  "activitiesUsingThisImage": "Aktiviteter som använder denna bild: ",
  "noActivitiesUsingThisImage": "Inga aktiviteter använder denna bild",
  "fileType": "Typ",
  "createImage": "Skapa utkast",
  "saving": "Sparar...",
  "changeImage": "Ersätt fil?",
  "cancelSelectedNewImageFile": "Avbryt val av ny bildfil",
  "fileNameRequired": "Filnamn är obligatoriskt",
  "titleRequired": "Titel är obligatoriskt",
  "fileRequired": "Fil är obligatorisk",
  "currentFile": "Aktuell fil",
  "enterFileName": "Ange filnamn",
  "oldVersionMessageBarTextImage": "Detta är en äldre version av bilden och representerar därför inte vad slutanvändare ser idag. Du hittar den senaste versionen här: ",
  "paginateNext": "Nästa",
  "paginateMaxPageSizeWarning": "Det går inte att visa fler än {{max}} objekt per sida. Värdet har satts till {{max}}.",
  "paginateMaxPageSizeWarningClose": "Stäng",
  "paginatePageSize": "Objekt per sida",
  "paginateShowingItems": "Visar {{displayed}} av {{total}} objekt",
  "paginatePrevious": "Föregående",
  "recacheNavigation": "Bygg om navigationscachen",
  "recacheNavigationPrompt": "Detta kommer att bygga om navigationens cache. Är du säker på att du vill fortsätta?",
  "activityWasActivated": "Aktiviteten aktiverades",
  "activityWasDeactivated": "Aktiviteten avaktiverades",
  "activityWasArchived": "Aktiviteten utgick",
  "activityWasUnarchived": "Aktiviteten ej längre utgången",
  "toolWasActivated": "Aktiverades",
  "toolWasDeactivated": "Avaktiverades",
  "archived": "Utgått",
  "toolWasArchived": "Utgick",
  "toolWasUnarchived": "Ej utgånget",
  "insertImage": "Infoga bild",
  "resizeImage": "Ändra bildstorlek",
  "addLinkToTextOrImage": "Länk till bild/textobjekt",
  "addImageLink": "Lägg till bildlänk",
  "editImageLink": "Redigera bildlänk",
  "removeLink": "Ta bort länk",
  "currentLink": "Nuvarande länk",
  "insertLink": "Infoga länk",
  "insertLinkTool": "Infoga länkverktyg",
  "activeTools": "Aktiva verktyg",
  "inactiveTools": "Inaktiva verktyg",
  "manualLink": "Manuell länk",
  "toolLink": "Verktyglänk",
  "text": "Text",
  "linkTextPlaceholder": "Text som ska visas",
  "removeImageLink": "Ta bort bildlänk",
  "checkedOutToMassPublishBarTitle": "Varning! Hantering av objekt utcheckat till annan användare kommer genomföras. Detta är inte rekommenderat.",
  "unknownUser": "Okänd användare",
  "processHasSubActivities": "Placering kan inte tas bort, då aktiviteten har underaktiviteter.",
  "mirroredChildrenProcess": "Placering kan inte tas bort, då aktiviteten är en källaktivitet till speglade aktiviteter.",
  "unableInactivate": "Inaktivering kan inte genomföras då aktiviteten har underaktiviteter",
  "errorInactivation": "Varning",
  "ok": "Ok",
  "cannotInactivateSourceActivity": "Inaktivering kan inte genomföras då aktiviteten är en källaktivitet för speglade aktiviteter.",
  "cannotModifyActivityWithSubActivities": "Ändring kan inte genomföras då aktiviteten har underaktiviteter.",
  "activityWithMirroredChildrenWarningMessage": "Detta är en källaktivitet med {{count}} st speglade aktiviteter",
  "width": "Bredd",
  "height": "Höjd",
  "maintainAspectRatio": "Behåll proportioner",
  "imageWidthInfo": "100% bredd motsvarar maxbredd av aktivitetsbeskrivningen.",
  "notUsedInAnyChapter": "Används inte i något kapitel",
  "navigationColumnRequired": "Kolumnval är obligatoriskt för innehållsöversikten",
  "searchFilter": "Sök ",
  "filterShowAll": "Visa alla",
  "filterListAriaLabel": "Filtreringsvärden för ",
  "setFilter": "Filtrera",
  "chooseFilter": "Välj filter",
  "selectedFiltersHeader": "Vald filtrering",
  "clearFilter": "Rensa filter",
  "clearAllFilters": "Rensa alla filter",
  "emptyFilterValue": "Tomt värde",
  "fileSizeTooLarge": "Filstorleken {{size}} MB överstiger den tillåtna gränsen på {{maxSize}} MB.",
  "editChapterForm": {
    "chapterFilters": "Filtrering",
    "chapterFilterHint": "Filtreringar du väljer här kommer att gälla för både söken och innehållsöversikten.",
    "chapterNavigationConfig": "Navigeringskonfiguration",
    "enableTableNavigation": "Aktivera innehållsöversikten",
    "navigationTableColumnTagId": "Kolumn",
    "navigationTableRowTagId": "Rad",
    "kmaVariantInUse": "Används av annat kapitel",
    "kmaVariantAlreadyUsed": "Varianten används redan av ett annat kapitel."
  },
  "utilityLinksAdminPage": "Vsaa-verktyg",
  "utilityLinksAdminPageDescription": "Här kan du uppdatera länkarna för Vsaa-verktygen.",
  "utilityLinkSettingsHeader": "Vsaa-verktyg",
  "utilityLinksManage": "Hantera Vsaa-verktyg",
  "utilityEmergencyInfoLabel": "Nödlägesinformation",
  "utilityImproveLabel": "Förbättra",
  "utilityDictionaryLabel": "Ordlista",
  "utilitySupportLabel": "Användarstöd",
  "utilityChatLabel": "Chatt för användarhjälp",
  "utilityTopBarVisibilityLabel": "Visa i toppmenyn",
  "saveUtilityLinks": "Spara Vsaa-verktyg",
  "utilityLinksDescription": "Här kan du ställa in länkarna till Vsaa-verktygen. Lämnas ett länkfält tomt så kommer länken inte visas i listan av Vsaa-verktyg för slutanvändare. Behöver länken innehålla den sidan som användaren befinner sig på när hen trycker på länken så kan den inkluderas genom att lägga in |CurrentPageUrl| på den platsen i länken.",
  "systemInfoBanner": {
    "title": "Systeminformation",
    "description": "Skapa och schemalägg meddelande som visas som banner för användare och administratörer i Vsaa.",
    "manage": "Hantera systeminformation",
    "messageLabel": "Meddelande",
    "publishedLabel": "Publicerad",
    "validFromLabel": "Visa från",
    "validToLabel": "Visa till",
    "dateLabel": "Datum",
    "datePlaceholder": "Välj datum",
    "timeLabel": "Tid",
    "timePlaceholder": "HH:mm",
    "timeValidationMessage": "Ange tid i 24-timmarsformat, till exempel 14:30.",
    "dateRangeValidationMessage": "Sluttiden kan inte vara före starttiden.",
    "expiredScheduleValidationMessage": "Bannern kan inte publiceras eftersom sluttiden redan har passerat. Du kan fortfarande spara ändringarna.",
    "save": "Spara",
    "publish": "Publicera",
    "unpublish": "Avpublicera"
  },
  "navigateToVsaa": "Navigera till Vsaa",
  "dataGridFieldLabels": {
    "draftCreatedBy": "Utcheckat till",
    "activityTitle": "Namn"
  },
  "complianceBannerText": "OBS! Detta arbetssätt är kopplat till kravefterlevnad!",
  "activityOverviewRequirementsHeading": "Kravefterlevnad",
  "expandAll": "Fäll ut allt",
  "collapseAll": "Fäll ihop alla",
  "currentLocation": "Nuvarande placering",
  "activityForm": {
    "activityTitleFieldLabel": "Namn",
    "activityTitleFieldPlaceholder": "Skriv aktivitetens namn här...",
    "activityTitleFieldHint": "Detta namn visas inte som rubrik för slutanvändare. Slutanvändare ser istället navigeringsnodens namn."
  },
  "primary": "Primär",
  "secondary": "Sekundär",
  "roleTitle": "Rollrubrik",
  "excelReport": {
    "download": "Excelrapport",
    "loading": "Skapar rapport..."
  },
  "createDraft": "Skapa utkast",
  "webUrl": "Namn",
  "documentLinkIconAltText": "Dokumentikon",
  "documentOverviewDocumentLinkDescription": "Dokumentet som öppnas via länken ovan kommer öppnas i skrivskyddat läge.",
  "activitiesUsingToolTable": {
    "processPathHeading": "Placering",
    "missingProcessPath": "(saknar placering)"
  },
  "kmaChapterLabel": "KMA-kapitel",
  "selectChapters": "Välj kapitel",
  "openImageViewer": "Visa bilden i större format",
  "closeImageViewer": "Stäng bildvisaren",
  "newDocument": "Nytt dokument"
}
